import { render, staticRenderFns } from "./CreateDeposit.vue?vue&type=template&id=52ed193b&"
import script from "./CreateDeposit.vue?vue&type=script&lang=js&"
export * from "./CreateDeposit.vue?vue&type=script&lang=js&"
import style0 from "./CreateDeposit.vue?vue&type=style&index=0&id=52ed193b&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports